import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adjustoverallsummary',
  templateUrl: './adjustoverallsummary.component.html',
  styleUrls: ['./adjustoverallsummary.component.css']
})
export class AdjustoverallsummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
